<template>
  <div class="main-dest">
    <div>
      <Menus
        :menu="menu"
        icon="https://dsmapi.logistics.systems/dsm6gicons/icons8-place-marker-64.png"
        @menuClicked="menuClicked"
      />
    </div>
    <div class="main-dest2">
      <div class="map-container" :style="{ maxHeight: showMap ? '50%' : '0', padding: showMap ? '5px' : '0' }">
        <CustomMap :viewMode="true" :hideSlot="true" ref="mainMap" />
      </div>
      <div class="table-container" :style="{ maxHeight: showMap ? '50%' : '100%', marginTop: showMap ? '5px' : '0' }">
        <TableBox
          title="Destination"
          :tableData="fullDestList"
          :maxSelection="1"
          :selectedRow.sync="selectedDest"
          :loading="fullDestLoading"
          @rowSelected="destSelected"
        />
      </div>

      <PopupEntry
        v-if="showPopup"
        :show.sync="showPopup"
        :title="entryTitle"
        :createdBy="createdBy"
        :updatedBy="updatedBy"
        @save="saveDest"
        :messages="entryMessages"
        :errorMessages.sync="Emessages"
        :successMessages="successMessages"
        :requiredError="requiredMessages"
        @requiredClicked="entryRequiredClicked"
        :viewMode="viewMode"
      >
        <div class="destination-code">
          <Input
            placeholder="Destination Code"
            :isRequired="true"
            :inputValue.sync="destinationCode"
            :isDisabled="isDestCodeAuto || viewMode || entryTitle == 'Edit Destination'"
            :errorMessage.sync="destinationCodeError"
            ref="destCode"
            validator="text,10,uppercase,alphanumeric,dash"
          />
          <CheckBox title="Active" style="margin-left: 5px" :isChecked.sync="destinationActive" />
        </div>

        <Tab :tabs="tabsItems" style="height: calc(100% - 29px)" :tabIndex.sync="currentTab">
          <!-- Destination Details -->
          <div slot="Destination Details">
            <div class="flex-row" style="margin-bottom: 5px">
              <BoxContainer title="Destination Type" style="flex-direction: row">
                <Dropdown
                  placeholder="Destination Type"
                  :isRequired="true"
                  :items="destTypeList"
                  :selectedObject.sync="selectedDestType"
                  itemKey="Type"
                  :isDisabled="viewMode"
                  :errorMessage.sync="destTypeError"
                  ref="destType"
                />
                <InputQuery
                  placeholder="Customer Code"
                  style="margin-left: 5px"
                  :items="customerCodeList"
                  itemKey="Customer Code - Description"
                  :selectedObject.sync="selectedCustomerCode"
                  :isDisabled="viewMode"
                  validator="text,113"
                />
              </BoxContainer>
              <CheckBox
                title="Own Staging Dest?"
                style="min-width: 145px; max-width: 145px; margin-top: 10px"
                :isChecked.sync="isOwnStagingDest"
                :isDisabled="viewMode"
              />
            </div>

            <InputQuery
              :isRequired="true"
              placeholder="Tariff Area"
              :items="tariffAreaList"
              :selectedObject.sync="selectedTariffArea"
              itemKey="Area Code - Description"
              :isDisabled="viewMode"
              :errorMessage.sync="tariffAreaError"
              ref="tariffArea"
            />
            <div class="flex-row">
              <Input
                :isRequired="true"
                placeholder="Company Name"
                :inputValue.sync="companyName"
                :isDisabled="viewMode"
                :errorMessage.sync="companyNameError"
                ref="compName"
                validator="text,100,uppercase,alphanumeric,all"
              />
              <Input
                :isRequired="false"
                placeholder="Short Name"
                :inputValue.sync="shortName"
                :isDisabled="viewMode"
                :errorMessage.sync="shortNameError"
                ref="shortName"
                validator="text,30,uppercase,alphanumeric,all"
              />
            </div>
            <AddressFormV2
              :address.sync="address"
              :addressRequired="addressRequired"
              :addressErrors.sync="addressErrors"
              :viewMode="viewMode"
              :postcodes="postcodeList"
              :states="stateList"
              :countries="countryList"
              ref="addressForm"
            />

            <div class="flex-row">
              <BoxContainer title="Required Time" style="flex-direction: row">
                <CheckBox
                  title="Office Hours?"
                  style="min-width: 120px"
                  :isChecked.sync="isOfficeHrs"
                  :isDisabled="viewMode"
                />
                <Input
                  placeholder="Required Time Description"
                  :inputValue.sync="requiredTimeDesc"
                  :isDisabled="viewMode"
                  :errorMessage.sync="requiredTimeDescError"
                  ref="reqTimeDesc"
                />
              </BoxContainer>
              <InputQuery
                placeholder="Zone Type"
                style="margin-top: 18px"
                :items="zoneList"
                :selectedObject.sync="selectedZone"
                itemKey="Zone Type - Description"
                :isDisabled="viewMode"
              />
            </div>

            <div class="flex-row">
              <Input
                placeholder="Phone No."
                :inputValue.sync="phone"
                :isDisabled="viewMode"
                :errorMessage.sync="phoneError"
                ref="phone"
                validator="text,20,,alphanumeric,all"
              />
              <Input
                placeholder="Fax No."
                :inputValue.sync="fax"
                :isDisabled="viewMode"
                :errorMessage.sync="faxError"
                ref="fax"
                validator="text,20,,alphanumeric,all"
              />
            </div>
            <Input
              placeholder="Email"
              :inputValue.sync="email"
              :isDisabled="viewMode"
              :errorMessage.sync="emailError"
              ref="email"
              :regex="emailRegex"
              validator="text,100,,alphanumeric,all"
            />
            <div class="flex-row">
              <Input
                placeholder="Contact"
                :inputValue.sync="contact"
                :isDisabled="viewMode"
                :errorMessage.sync="contactError"
                ref="contact"
              />
              <Input
                placeholder="H/P No."
                :inputValue.sync="hpno"
                :isDisabled="viewMode"
                :errorMessage.sync="hpnoError"
                ref="hpno"
                validator="text,20,,alphanumeric,all"
              />
            </div>
            <div class="flex-row">
              <InputQuery
                placeholder="Opr Tariff Area"
                :items="oprTariffAreaList"
                :selectedObject.sync="selectedOprTariffArea"
                itemKey="Area Code - Description"
                :isDisabled="viewMode"
              />
              <Dropdown
                placeholder="Premises Is"
                :items="premisesIsList"
                :selectedObject.sync="selectedPremisesIs"
                itemKey="Type"
                :isDisabled="viewMode"
              />
            </div>
          </div>

          <!-- Destination Location -->
          <div slot="Destination Location">
            <RemarksBox
              title="Default Remarks"
              style="height: 100px"
              :text.sync="remarks"
              :isDisabled="viewMode"
              :maxLength="200"
              :errorMessage.sync="remarksError"
              ref="remarks"
            />
            <div class="flex-row">
              <Input
                placeholder="Average Stuff Time (Hour(s))"
                :inputValue.sync="avgStuffTime"
                :isDisabled="viewMode"
                :regex="avgStuffTimeRegex"
                :errorMessage.sync="avgStuffTimeError"
                ref="avgStuffTime"
              />
              <Input
                placeholder="Average Unstuff Time (Hour(s))"
                :inputValue.sync="avgUnstuffTime"
                :isDisabled="viewMode"
                :regex="avgUnstuffTimeRegex"
                :errorMessage.sync="avgUnstuffTimeError"
                ref="avgUnstuffTime"
              />
            </div>
            <Input
              placeholder="Container Count (Ability to store # of containers)"
              :inputValue.sync="containerCount"
              :isDisabled="viewMode"
              :regex="containerCountRegex"
              :errorMessage.sync="containerCountError"
              ref="containerCount"
            />
            <div class="flex-row" style="align-items: flex-start">
              <BoxContainer style="width: 40%; height: 290px" title="Address Summary">
                <div style="font-weight: bold">{{ companyName || '--' }}</div>
                <div>{{ address ? address['addressLine1'] || '--' : '--' }}</div>
                <div>{{ address ? address['addressLine2'] || '--' : '--' }}</div>
                <div>{{ address ? address['addressLine3'] || '--' : '--' }}</div>
                <div>{{ address ? address['addressLine4'] || '--' : '--' }}</div>
                <div
                  >{{ address ? address['postcode'] || '--' : '--' }},
                  {{ address ? address['city'] || '--' : '--' }}</div
                >
                <div
                  >{{ address ? address['state'] || '--' : '--' }},
                  {{ address ? address['country'] || '--' : '--' }}</div
                >
                <div
                  ><button style="margin-top: 5px; width: 100%" @click="addressOnMap" v-if="!viewMode"
                    >Show Address On Map</button
                  ></div
                >
                <div
                  ><button style="margin-top: 5px; width: 100%" @click="addressFromMarker" v-if="!viewMode"
                    >Update Address from Marker</button
                  ></div
                >
              </BoxContainer>
              <CustomMap
                style="width: 60%; height: 300px"
                ref="customMap"
                :slotFloat="true"
                :openMenu.sync="openMapMenu"
                :maxMarkerCount="1"
                :markers.sync="destinationMarkers"
                :viewMode="viewMode"
              />
            </div>

            <!-- <GmapLocation :isGeofence="true" :data="gmapDetails" :showGeofence.sync="gmapGeofence" /> -->
          </div>

          <!-- Attachments -->
          <div slot="Attachments" style="height: 100%; display: flex; flex-direction: column">
            <Attachments
              :attachments.sync="attachments"
              :viewMode="viewMode"
              @attachmentsDeleted="attachmentsDeleted"
            />
          </div>
        </Tab>
      </PopupEntry>

      <!-- Import geofence -->
      <div v-if="showImportGeofencePopup" id="upload-popup">
        <Button class="close-button" @click="closeUploadPopup(true)">Close</Button>
        <Button class="submit-button" :disabled="geofenceXML === '' ? true : false" @click="submitGeofenceFile()"
          >Submit</Button
        >
        <!-- <div class="legend-container">
          <img style="max-height: 2em" src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Warning.svg/1200px-Warning.svg.png" alt="">
           - Selected destination already has a Geofence.
        </div> -->
        <div class="title">Import Geofence</div> <br />
        <Input
          placeholder="Choose kml file"
          textType="file"
          @fileChanged="readFile($event)"
          id="geofence-file-input"
          accept=".kml"
        />
        <br />
        <div class="match-container" v-if="geofenceMatchList.length > 0">
          <div class="no-matches-found">
            <div class="title"> No matches found ({{ noMatchesFoundList.length }}) </div>
            <div class="title-container">
              <div class="title">Name from file</div>
              <div class="title">Match</div>
            </div>
            <div class="list-container">
              <div class="list-item" v-for="(match, index) in noMatchesFoundList" :key="match['Name']">
                <div class="name">
                  {{ match['Name'] }}
                </div>
                <div class="match">
                  <Tooltip
                    class="tooltip-class"
                    v-if="
                      noMatchesFoundList[index]['Selected Match'] &&
                      noMatchesFoundList[index]['Selected Match']['Geofence'] !== '0'
                    "
                    icon="https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Warning.svg/1200px-Warning.svg.png"
                    tooltipText="Geofence already exists. Submitting will replace the existing geofence."
                    style="max-height: 2em"
                  />
                  <Dropdown
                    placeholder="Destination Code (Company Name)"
                    :items="fullDestListForGeofence"
                    itemKey="Destination Code and Company"
                    :selectedObject.sync="noMatchesFoundList[index]['Selected Match']"
                  />
                  <!-- Match: {{ match['Selected Match']['Destination Code']}} -->
                </div>
              </div>
            </div>
          </div>
          <div class="match-found">
            <div class="title"> Match found ({{ matchesFoundList.length }}) </div>
            <div class="title-container">
              <div class="title">Name from file</div>
              <div class="title">Match</div>
            </div>
            <div class="list-container">
              <div class="list-item" v-for="(match, index) in matchesFoundList" :key="match['Name']">
                <div class="name">
                  {{ match['Name'] }}
                </div>
                <div class="match">
                  <Tooltip
                    class="tooltip-class"
                    v-if="
                      matchesFoundList[index]['Selected Match'] &&
                      matchesFoundList[index]['Selected Match']['Geofence'] !== '0'
                    "
                    icon="https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Warning.svg/1200px-Warning.svg.png"
                    tooltipText="Geofence already exists. Submitting will replace the existing geofence."
                    style="max-height: 2em"
                  />
                  <Dropdown
                    placeholder="Destination Code (Company Name)"
                    :items="fullDestListForGeofence"
                    itemKey="Destination Code and Company"
                    :selectedObject.sync="matchesFoundList[index]['Selected Match']"
                  />
                  <!-- Match: {{ match['Selected Match']['Destination Code']}} -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <PopupV2
      :show="confirmAddressPopup"
      :buttons="addressPopupButtons"
      title="Confirm Your Address"
      @buttonClicked="confirmAddressButtonClicked"
    >
      <div>We've found {{ foundAddresses.length }} address{{ foundAddresses.length > 1 ? 'es' : '' }}.</div>
      <div>Please confirm the address.</div>

      <div v-for="(f, i) in foundAddresses" :key="i" class="address_details">
        <CheckBox
          :title="f['formatted_address']"
          :isChecked.sync="f['checked']"
          @checkBoxClicked="addressCheckBoxClicked(i)"
        />
      </div>
    </PopupV2>

    <!-- Activate for Clock In/Out  -->
    <PopupV2
      :show="showActivateClockInOutPopup"
      :buttons="activateClockInOutButtons"
      :title="activateClockInOutMenuTitle"
      width="450px"
      @buttonClicked="activateClockInOutButtonClicked"
    >
      <div>
        <CustomMap
          style="width: 100%; height: 250px; padding: 10px;"
          ref="clockInMap"
          :maxMarkerCount="1"
          :hideSlot="true"
          :markers.sync="clockInOutMarkers"
          :viewMode="true"
        />
        <div>
          <div style="font-weight: bold">{{ companyName || '--' }}</div>
          <div>{{ address ? address['addressLine1'] || '--' : '--' }}</div>
          <div>{{ address ? address['addressLine2'] || '--' : '--' }}</div>
          <div>{{ address ? address['addressLine3'] || '--' : '--' }}</div>
          <div>{{ address ? address['addressLine4'] || '--' : '--' }}</div>
          <div>
            {{ address ? address['postcode'] || '--' : '--' }},
            {{ address ? address['city'] || '--' : '--' }}
          </div>
          <div>
            {{ address ? address['state'] || '--' : '--' }},
            {{ address ? address['country'] || '--' : '--' }}
          </div>
        </div>
      </div>
    </PopupV2>
  </div>
</template>

<script>
/* eslint-disable */
import GoogleMap from '@/components/GoogleMap.vue';
import GmapLocation from '@/components/GmapLocation.vue';
import Attachments from '@/components/tabComponents/Attachments.vue';
import { doubleMetaphone } from 'double-metaphone';

export default {
  components: {
    GoogleMap,
    GmapLocation,
    Attachments,
  },
  computed: {
    addressPopupButtons: function () {
      let buttons = [];

      buttons.push({ text: 'Confirm', disabled: this.selectedAddress ? false : true });
      buttons.push({ text: 'Cancel', color: 'red', textColor: 'white' });

      return buttons;
    },
    selectedAddress: function () {
      return this.foundAddresses.find((f) => f['checked']);
    },

    //#region import geofence
    submitGeofencePopupButtons: function () {
      let buttons = [];

      buttons.push({ text: 'Confirm' });
      buttons.push({ text: 'Cancel', color: 'red', textColor: 'white' });

      return buttons;
    },

    noMatchesFoundList: function () {
      return this.geofenceMatchList.filter(function (el) {
        return !el['Matched'];
      });
    },

    matchesFoundList: function () {
      return this.geofenceMatchList.filter(function (el) {
        return el['Matched'];
      });
    },

    matchListToPost: function () {
      return [...this.matchesFoundList, ...this.noMatchesFoundList];
    },

    fullDestListForGeofence: function () {
      let list = JSON.parse(JSON.stringify(this.fullDestList));

      list.forEach((dest) => {
        dest['Destination Code and Company'] = dest['Destination Code'] + ' (' + dest['Company'] + ')';
      });
      return list;
    },

    //#endregion

    //#region Activate for Clock In/Out
    activateClockInOutMenuTitle: function () {
      return (!this.isDeactivate) ?
        'Activate for Clock In/Out'
        : 'Deactivate for Clock In/Out';
    },
    activateClockInOutButtons: function () {
      const buttons = [];

      buttons.push({ text: 'Confirm' });
      buttons.push({ text: 'Cancel', color: 'red', textColor: 'white' });

      return buttons;
    },
    //#endregion
  },
  data: function () {
    return {
      showMap: false,

      showPopup: false,
      Emessages: [],
      successMessages: [],
      requiredMessages: [],
      entryTitle: '',
      updatedBy: '',
      createdBy: '',

      destAction: '',

      menu: [
        {
          title: 'New Destination',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: 'MnuNew',
          visible: true,
          enabled: false,
        },
        {
          title: 'Edit Destination',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png',
          key: 'MnuEdit',
          visible: true,
          enabled: false,
        },
        {
          title: 'Delete Destination',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          key: 'MnuDelete',
          visible: false,
          enabled: false,
        }, //hide delete from sas
        {
          title: 'View Destination',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          key: 'MnuQuery',
          visible: true,
          enabled: false,
        },
        { title: 'Show Map', icon: 'https://dsmapi.logistics.systems/dsm6gicons/Map.png' },
        { title: 'Import Geofence', icon: 'https://i.imgur.com/Z2N31cH.png' },
        {
          title: 'Activate for Clock In/Out',
          icon: 'https://dsmlib.logistics.systems/Icons/Approve.png',
          key: 'MnuActivateClockInOut',
          visible: true,
          enabled: false,
        },
      ],
      tabsItems: [{ title: 'Destination Details' }, { title: 'Destination Location' }, { title: 'Attachments' }],
      currentTab: 0,

      errorMapping: [
        { key: 'destCode', tab: -1 },
        { key: 'destType', tab: 0 },
        { key: 'tariffArea', tab: 0 },
        { key: 'compName', tab: 0 },
        { key: 'shortName', tab: 0 },
        { key: 'addr1', tab: 0 },
        { key: 'addr2', tab: 0 },
        { key: 'addr3', tab: 0 },
        { key: 'addr4', tab: 0 },
        { key: 'city', tab: 0 },
        { key: 'reqTimeDesc', tab: 0 },
        { key: 'phone', tab: 0 },
        { key: 'fax', tab: 0 },
        { key: 'email', tab: 0 },
        { key: 'contact', tab: 0 },
        { key: 'hpno', tab: 0 },
        { key: 'remarks', tab: 1 },
        { key: 'avgStuffTime', tab: 1 },
        { key: 'avgUnstuffTime', tab: 1 },
        { key: 'containerCount', tab: 1 },
      ],

      fullDestList: [],
      selectedDest: [],

      fullDestLoading: false,
      isDestCodeAuto: false,

      zoneList: [],

      viewMode: false,

      destinationCode: '',
      destinationCodeError: '',
      destinationActive: false,

      latLngSearch: '',

      //#region Upload popup data
      showUploadPopup: true,
      //#endregion

      //#region Destination Details Data
      destTypeList: [
        { '#': 1, Type: 'Consignee/Shipper' },
        { '#': 2, Type: 'Port/Depot' },
      ],
      selectedDestType: null,
      destTypeError: '',
      customerCodeList: [],
      selectedCustomerCode: null,
      isOwnStagingDest: false,
      tariffAreaList: [],
      selectedTariffArea: null,
      tariffAreaError: '',
      companyName: '',
      companyNameError: '',
      shortName: '',
      shortNameError: '',
      postcodeList: [],
      stateList: [],
      countryList: [],
      address: {
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        postcode: '',
        city: '',
        state: '',
        country: '',
      },
      addressRequired: {
        addressLine1: true,
        addressLine2: false,
        addressLine3: false,
        addressLine4: false,
        postcode: false,
        city: false,
        state: false,
        country: false,
      },
      addressErrors: {
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        city: '',
      },
      isOfficeHrs: false,
      requiredTimeDesc: '',
      requiredTimeDescError: '',
      zoneList: [],
      selectedZone: null,
      phone: '',
      phoneError: '',
      fax: '',
      faxError: '',
      email: '',
      emailError: '',
      emailRegex: {
        regex: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
        message: 'The email input is not in correct format',
        live: false,
        autoClear: false,
      },
      contact: '',
      contactError: '',
      hpno: '',
      hpnoError: '',
      oprTariffAreaList: [],
      selectedOprTariffArea: null,
      premisesIsList: [
        { '#': 1, Type: 'Secured' },
        { '#': 2, Type: 'Unsecured' },
      ],
      selectedPremisesIs: null,
      //#endregion

      //#region Destination Location
      remarks: '',
      remarksError: '',
      avgStuffTime: '',
      avgStuffTimeError: '',
      avgStuffTimeRegex: {
        regex: /\d*\.?\d*/g,
        live: true,
        autoClear: false,
      },
      avgUnstuffTime: '',
      avgUnstuffTimeError: '',
      avgUnstuffTimeRegex: {
        regex: /\d*\.?\d*/g,
        live: true,
        autoClear: false,
      },
      containerCount: '',
      containerCountError: '',
      containerCountRegex: {
        regex: /\d/g,
        live: true,
        autoClear: false,
      },
      destinationMarkers: [],
      openMapMenu: false,
      confirmAddressPopup: false,
      foundAddresses: [],
      confirmAddressResolve: null,
      //#endregion

      //#region Attachments
      attachments: [],
      deletedAttachments: [],
      //#endregion

      //#region Geofence input
      geofenceXML: '',
      geofenceMatchList: [],
      showImportGeofencePopup: false,
      showSubmitGeofencePopup: false,
      showSubmitGeofenceSuccessPopup: false,
      showSubmitGeofenceFailPopup: false,
      dropdownId: 0,
      geofences: [],
      //#endregion

      //#region Activate for Clock In/Out
      showActivateClockInOutPopup: false,
      clockInOutMarkers: [],
      clockInOutGeofence: [],
      isDeactivate: false,
      //#endregion
    };
  },
  props: {},
  methods: {
    async sasControlFunction() {
      this.$fullscreenLoading('Checking Security Access');
      const sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=Master&page=Destination`);
      sasControl.forEach((k) => {
        //key in menu same as control value from api
        const selectedMenu = this.menu.find((m) => m['key'] == k['Control']);
        if (selectedMenu) {
          selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
        }
      });
      this.$fullscreenLoading('');
    },
    //Button Actions
    menuClicked: async function (e) {
      this.clearEntryMessages();

      switch (e.title) {
        case 'New Destination':
          this.$fullscreenLoading('Please Wait');
          this.isDestCodeAuto =
            (await this.$apiCallV2('/DestinationList/CheckIsMasterCodeAuto'))[0]['MasterCodeAuto'] == 1;
          this.$fullscreenLoading();

          if (this.isDestCodeAuto) {
            this.destinationCode = '**********';
          }

          this.entryTitle = 'New Destination';
          this.showPopup = true;
          break;
        case 'Edit Destination':
          if (!this.selectedDest[0]) {
            this.$showAlert('error', 'No Destination Selected', `Please select a record to edit`);
          } else {
            await this.retrieveTableDest();
            this.entryTitle = 'Edit Destination';
            this.showPopup = true;
          }
          break;
        case 'Delete Destination':
          if (this.selectedDest.length == 0) {
            await this.$showAlert('error', 'No Destination Selected', 'Please select a destination to delete');
          } else {
            let isDelete = await this.$showAlert(
              'warning',
              'Delete Destination',
              `Are you sure want to delete destination ${this.selectedDest[0]['Destination Code']}?`,
              [
                { text: 'Delete', color: 'red', textColor: 'white' },
                { text: 'Cancel', color: 'gray', textColor: 'white' },
              ],
            );

            if (isDelete == 'Delete') {
              // Delete the destination
              let delDest = this.$deepTrimJsonV3(
                await this.$apiCallV2('/DestinationList/SaveDestination', {
                  action: 'D',
                  Destination_code: this.selectedDest[0]['Destination Code'],
                }),
              );

              if (this.selectedDest[0]['Clock In/Out'] == 'Activated') {
                // Remove clock in/out geofence details
                await this.$apiCallV2('/DestinationList/SaveClockInOutGeofence', {
                  action: 'D',
                  poicode: this.selectedDest[0]['Destination Code'],
                });
              }

              if (delDest[0]['Results'] == 0) {
                this.$showAlert(
                  'success',
                  'Destination Deleted',
                  `Successfully deleted ${delDest[0]['Destination_Code']}!`,
                );
                this.selectedDest = [];
                this.getAllDestination();
              } else {
                this.$showAlert(
                  'error',
                  'Destination Not Deleted',
                  `There was an error occurred while trying to delete ${delDest[0]['Destination Code']} - ${delDest[0]['ErrMsg']}<br><br>Please try again.`,
                );
              }
            }
          }
          break;
        case 'View Destination':
          if (!this.selectedDest[0]) {
            this.$showAlert('error', 'No Destination Selected', `Please select a record to view`);
          } else {
            await this.retrieveTableDest();
            this.entryTitle = 'View Destination';
            this.showPopup = true;
            this.viewMode = true;
          }
          break;
        case 'Show Map':
        case 'Hide Map':
          this.showMap = !this.showMap;

          this.menu[4]['title'] = this.showMap ? 'Hide Map' : 'Show Map';
          break;
        case 'Import Geofence':
          this.showImportGeofencePopup = true;
          // document.getElementById('upload-popup').style.display="block";
          break;
        case 'Activate for Clock In/Out':
          if (!this.selectedDest[0]) {
            this.$showAlert('error', 'No Destination Selected', 'Please select a destination to activate for clock in/out.');
          } else {
            await this.loadActivateClockInOutPopup();
          }
          break;
        case 'Deactivate for Clock In/Out':
          if (!this.selectedDest[0]) {
            this.$showAlert('error', 'No Destination Selected', 'Please select a destination to deactivate for clock in/out.');
          } else {
            await this.loadActivateClockInOutPopup();
          }
          break;
      }
    },
    requiredClicked: function (elm) {
      var errorItem = this.requiredMessages.filter((e) => {
        return e['Key'] == elm;
      })[0];
      this.$bus.$emit('destinationSetFocus', { element: elm, page: errorItem['Page'] });
    },
    clearMsgs: function () {
      this.requiredMessages = [];
      this.Emessages = [];
      this.successMessages = [];
    },

    getAllDestination: async function () {
      this.fullDestLoading = true;
      this.fullDestList = [];
      this.fullDestList = this.$deepTrimJsonV3(
        await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'destination', module: 'MASTER' }),
      );
      this.fullDestLoading = false;
    },

    checkFields: function () {
      this.clearEntryMessages();

      if (!this.destinationCode) {
        this.destinationCodeError = 'Destination Code is required!';
        this.requiredMessages.push({ Key: 'destCode', Value: 'Destination Code is required!' });
      } else {
        if (this.destinationCode.length > 10) {
          this.destinationCodeError = 'Destination Code cannot exceed 10 characters!';
          this.requiredMessages.push({ Key: 'destCode', Value: 'Destination Code cannot exceed 10 characters!' });
        }
      }
      if (!this.selectedDestType) {
        this.destTypeError = 'Destination Type is required!';
        this.requiredMessages.push({ Key: 'destType', Value: 'Destination Type is required!' });
      }
      if (!this.selectedTariffArea) {
        this.tariffAreaError = 'Tariff Area is required!';
        this.requiredMessages.push({ Key: 'tariffArea', Value: 'Tariff Area is required!' });
      }
      if (!this.companyName) {
        this.companyNameError = 'Company Name is required!';
        this.requiredMessages.push({ Key: 'compName', Value: 'Company Name is required!' });
      } else {
        if (this.companyName.length > 100) {
          this.companyNameError = 'Company Name cannot exceed 100 characters!';
          this.requiredMessages.push({ Key: 'compName', Value: 'Company Name cannot exceed 100 characters!' });
        }
      }
      if (this.shortName.length > 30) {
        this.shortNameError = 'Short Name cannot exceed 30 characters!';
        this.requiredMessages.push({ Key: 'shortName', Value: 'Short Name cannot exceed 30 characters!' });
      }
      if (!this.address.addressLine1.trim()) {
        this.addressErrors.addressLine1 = 'Address Line 1 is required!';
        this.requiredMessages.push({ Key: 'addr1', Value: 'Address Line 1 is required!' });
      } else {
        if (this.address.addressLine1.length > 40) {
          this.addressErrors.addressLine1 = 'Address Line 1 cannot exceed 40 characters!';
          this.requiredMessages.push({ Key: 'addr1', Value: 'Address Line 1 cannot exceed 40 characters!' });
        }
      }
      if (this.address.addressLine2.length > 40) {
        this.addressErrors.addressLine2 = 'Address Line 2 cannot exceed 40 characters!';
        this.requiredMessages.push({ Key: 'addr2', Value: 'Address Line 2 cannot exceed 40 characters!' });
      }
      if (this.address.addressLine3.length > 40) {
        this.addressErrors.addressLine3 = 'Address Line 3 cannot exceed 40 characters!';
        this.requiredMessages.push({ Key: 'addr3', Value: 'Address Line 3 cannot exceed 40 characters!' });
      }
      if (this.address.addressLine4.length > 40) {
        this.addressErrors.addressLine4 = 'Address Line 4 cannot exceed 40 characters!';
        this.requiredMessages.push({ Key: 'addr4', Value: 'Address Line 4 cannot exceed 40 characters!' });
      }
      if (this.address.city.length > 30) {
        this.addressErrors.city = 'City cannot exceed 30 characters!';
        this.requiredMessages.push({ Key: 'city', Value: 'City cannot exceed 30 characters!' });
      }
      if (this.requiredTimeDesc.length > 20) {
        this.requiredTimeDescError = 'Required Time Description cannot exceed 20 characters!';
        this.requiredMessages.push({
          Key: 'reqTimeDesc',
          Value: 'Required Time Description cannot exceed 20 characters!',
        });
      }
      if (this.phone.length > 20) {
        this.phoneError = 'Phone No. cannot exceed 20 characters!';
        this.requiredMessages.push({ Key: 'phone', Value: 'Phone No. cannot exceed 20 characters!' });
      }
      if (this.fax.length > 20) {
        this.faxError = 'Fax No. cannot exceed 20 characters!';
        this.requiredMessages.push({ Key: 'fax', Value: 'Fax No. cannot exceed 20 characters!' });
      }
      if (this.email.length > 100) {
        this.emailError = 'Email cannot exceed 100 characters!';
        this.requiredMessages.push({ Key: 'email', Value: 'Email cannot exceed 100 characters!' });
      }
      if (this.contact.length > 100) {
        this.contactError = 'Contact cannot exceed 100 characters!';
        this.requiredMessages.push({ Key: 'contact', Value: 'Contact cannot exceed 100 characters!' });
      }
      if (this.hpno.length > 20) {
        this.hpnoError = 'H/P No. cannot exceed 20 characters!';
        this.requiredMessages.push({ Key: 'hpno', Value: 'H/P No. cannot exceed 20 characters!' });
      }

      if (this.remarks.length > 200) {
        this.remarksError = 'Default Remarks cannot exceed 200 characters!';
        this.requiredMessages.push({ Key: 'remarks', Value: 'Default Remarks cannot exceed 200 characters!' });
      }
      if (!this.avgStuffTime.match(/^\d*\.?\d*$/g) && this.avgStuffTime) {
        this.avgStuffTimeError = 'Average Stuff Time format error!';
        this.requiredMessages.push({
          key: 'avgStuffTime',
          value: 'Average Stuff Time format error! Please make sure input is in proper decimal format.',
        });
      } else {
        if (+this.avgStuffTime > 900000000000000) {
          this.avgStuffTimeError = 'Average Stuff Time value too big!';
          this.requiredMessages.push({ key: 'avgStuffTime', value: 'Average Stuff Time value too big!' });
        }
      }
      if (!this.avgUnstuffTime.match(/^\d*\.?\d*$/g) && this.avgUnstuffTime) {
        this.avgUnstuffTimeError = 'Average Unstuff Time format error!';
        this.requiredMessages.push({
          key: 'avgUnstuffTime',
          value: 'Average Unstuff Time format error! Please make sure input is in proper decimal format.',
        });
      } else {
        if (+this.avgUnstuffTime > 900000000000000) {
          this.avgUnstuffTimeError = 'Average Unstuff Time value too big!';
          this.requiredMessages.push({ key: 'avgUnstuffTime', value: 'Average Unstuff Time value too big!' });
        }
      }
      if (+this.containerCount > 2000000000) {
        this.containerCountError = 'Container Count value too big!';
        this.requiredMessages.push({ key: 'containerCount', value: 'Container Count value too big!' });
      }

      return this.requiredMessages.length > 0;
    },

    saveDest: async function () {
      this.$fullscreenLoading('Saving');
      this.clearMsgs();

      if (this.checkFields()) {
        return;
      } else {
        let geofenceToPost = [];
        let latLng = ['', ''];
        if (this.destinationMarkers.length > 0) {
          if (this.destinationMarkers[0]['position']) {
            latLng[0] =
              this.destinationMarkers[0]['position']['lat'] ?
                this.destinationMarkers[0]['position']['lat'].toString()
              : '';
            latLng[1] =
              this.destinationMarkers[0]['position']['lng'] ?
                this.destinationMarkers[0]['position']['lng'].toString()
              : '';
          }

          let geo = this.destinationMarkers[0]['geofence'];
          if (geo) {
            geo.forEach((g, i) =>
              geofenceToPost.push({
                VertexID: (i + 1).toString(),
                gfLat: (Math.round(g.lat * 10000000) / 10000000).toString(),
                gfLon: (Math.round(g.lng * 10000000) / 10000000).toString(),
              }),
            );
          }
        }
        let attachmentToPost = this.attachments
          .filter((a) => a['attachmentaction'])
          .concat(this.deletedAttachments.filter((d) => d['attachmentaction']));

        let dataToPost = {
          action: this.entryTitle[0],
          Destination_code: this.destinationCode,
          Cu_Number: this.selectedCustomerCode ? this.selectedCustomerCode['Customer Code'] : '',
          Company: this.companyName,
          DestShortName: this.shortName,
          Addr1: this.address['addressLine1'],
          Addr2: this.address['addressLine2'],
          Addr3: this.address['addressLine3'],
          Addr4: this.address['addressLine4'],
          PostCode: this.address['postcode'],
          City: this.address['city'],
          State: this.address['state'],
          Country: this.address['country'],
          Attn: this.contact,
          Phone: this.phone,
          Phone2: this.hpno,
          Fax: this.fax,
          Fax2: '',
          Email: this.email,
          Email2: '',
          ZoneType: this.selectedZone ? this.selectedZone['Zone Type'] : '',
          CHAMAreaCode: this.selectedTariffArea ? this.selectedTariffArea['Area Code'] : '',
          DestinationType:
            this.selectedDestType ?
              this.selectedDestType['Type'] == 'Consignee/Shipper' ?
                '0'
              : '1'
            : '',
          DateUpdated: this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd HH:mm:ss'),
          ContainerCount: this.containerCount,
          AvgUnstuffTime: this.avgUnstuffTime,
          AvgStuffTime: this.avgStuffTime,
          Longtitude: Math.round(latLng[1] * 10000000000) / 10000000000,
          Latitude: Math.round(latLng[0] * 10000000000) / 10000000000,
          Height: null,
          OfficeHrs: this.isOfficeHrs ? '1' : '0',
          OprCHAMAreaCode: this.selectedOprTariffArea ? this.selectedOprTariffArea['Area Code'] : '',
          ReqTimeDesc: this.requiredTimeDesc,
          DefaultRemarks: this.remarks,
          IsTransitDest: this.isOwnStagingDest ? '1' : '0',
          Secured:
            this.selectedPremisesIs ?
              this.selectedPremisesIs['Type'] == 'Secured' ?
                '1'
              : '0'
            : '',
          Active: this.destinationActive ? '1' : '0',
          Geofence: geofenceToPost,
          Attachment: attachmentToPost,
        };

        this.$fullscreenLoading('Saving Destination');
        var postUpdate = await this.$apiCallV2('/DestinationList/SaveDestination', dataToPost);
        this.$fullscreenLoading();

        if (this.selectedDest[0] && this.selectedDest[0]['Clock In/Out'] == 'Activated') {
          // Update clock in/out geofence details
          let clockInOutData = {
            action: this.entryTitle[0],
            poicode: this.destinationCode,
            name: this.companyName,
            addr1: this.address['addressLine1'],
            addr2: this.address['addressLine2'],
            addr3: this.address['addressLine3'],
            addr4: this.address['addressLine4'],
            postcode: this.address['postcode'],
            city: this.address['city'],
            state: this.address['state'],
            country: this.address['country'],
            attn: this.contact,
            phone: this.phone,
            phone2: this.hpno,
            zonetype: this.selectedZone ? this.selectedZone['Zone Type'] : '',
            latitude: Math.round(latLng[0] * 10000000000) / 10000000000,
            longitude: Math.round(latLng[1] * 10000000000) / 10000000000,
            geofence: geofenceToPost,
          }
          this.$fullscreenLoading('Saving Clock In/Out Details');
          var clockInOutPostUpdate = await this.$apiCallV2('/DestinationList/SaveClockInOutGeofence', clockInOutData);
          this.$fullscreenLoading();

          if (clockInOutPostUpdate[0].Results >= 1) {
            this.Emessages.push(clockInOutPostUpdate[0].ErrMsg);
          }

          // clear data
          this.activateClockInOutButtonClicked('');
        }

        if (postUpdate[0].Results >= 1) {
          this.Emessages.push(postUpdate[0].ErrMsg);
        } else {
          this.getAllDestination();
          this.viewMode = true;
          this.successMessages.push('Successfully saved Destination!');
        }
      }
    },
    retrieveTableDest: async function () {
      this.$fullscreenLoading('Getting Details');
      let details = this.$jsonNullToStringV2(
        this.$deepTrimJsonV3(
          (
            await this.$apiCallV2(
              `/DestinationList/GetDetailsMaster?recordID=${this.selectedDest[0]['Destination Code']}`,
            )
          )['Destination'],
        ),
      );
      let attachments = await this.$apiCallV2(
        `/DestinationList/GetAttachment?refno=${this.selectedDest[0]['Destination Code']}`,
      );
      this.$fullscreenLoading();

      if (!this.address) {
        this.address = {
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          addressLine4: '',
          postcode: '',
          city: '',
          state: '',
          country: '',
        };
      }

      this.createdBy = details['UserID'];
      this.updatedBy = `${details['UserID']} ${new Date(details['DateUpdated']) ? this.$dateTime.getDateTime(new Date(details['DateUpdated']), 'dd/MM/yyyy HH:mm') : ''}`;

      this.destinationCode = details['Destination_code'];
      this.destinationActive = details['Active'] == '1';

      //#region Destination Details
      this.selectedDestType =
        details['DestinationType'] == '0' ? this.destTypeList[0]
        : details['DestinationType'] == 1 ? this.destTypeList[1]
        : null;
      this.selectedCustomerCode = this.customerCodeList.find((c) => c['Customer Code'] == details['Cu_number']);
      this.isOwnStagingDest = details['IsTransitDest'] == '1';
      this.selectedTariffArea = this.tariffAreaList.find((t) => t['Area Code'] == details['CHAMAreaCode']);
      this.companyName = details['Company'];
      this.shortName = details['Destination'];
      this.address['addressLine1'] = details['Addr1'] ?? '';
      this.address['addressLine2'] = details['Addr2'] ?? '';
      this.address['addressLine3'] = details['Addr3'] ?? '';
      this.address['addressLine4'] = details['Addr4'] ?? '';
      this.address['postcode'] = details['PostCode'] ?? '';
      this.address['city'] = details['City'] ?? '';
      this.address['state'] = details['State'] ?? '';
      this.address['country'] = details['Country'] ?? '';
      this.isOfficeHrs = details['OfficeHrs'] == '1';
      this.requiredTimeDesc = details['ReqTimeDesc'] ?? '';
      this.selectedZone = this.zoneList.find((z) => z['Zone Type'] == details['ZoneType']);
      this.phone = details['Phone'] ?? '';
      this.fax = details['Fax'] ?? '';
      this.email = details['Email'] ?? '';
      this.contact = details['Attn'] ?? '';
      this.hpno = details['Phone2'] ?? '';
      this.selectedOprTariffArea = this.oprTariffAreaList.find((o) => o['Area Code'] == details['OprCHAMAreaCode']);
      this.selectedPremisesIs = details['Secured'] == 1 ? this.premisesIsList[0] : this.premisesIsList[1];
      //#endregion

      //#region Destination Location
      this.remarks = details['DefaultRemarks'] ?? '';
      this.avgStuffTime = details['AvgStuffTime'] ?? '';
      this.avgUnstuffTime = details['AvgUnstuffTime'] ?? '';
      this.containerCount = details['ContainerCount'] ?? '';

      if (details['Longtitude'] && details['Latitude'] && details['Geofence']) {
        const geofencePath = details['Geofence'].map((g) => ({
          lat: parseFloat(g['gfLat']),
          lng: parseFloat(g['gfLon']),
        }));

        this.destinationMarkers.push({
          position: {
            lat: parseFloat(details['Latitude']),
            lng: parseFloat(details['Longtitude']),
          },
          geofence: geofencePath,
        });
      } else if (details['Geofence']) {
        const geofencePath = details['Geofence'].map((g) => ({
          lat: parseFloat(g['gfLat']),
          lng: parseFloat(g['gfLon']),
        }));
        const bounds = new google.maps.LatLngBounds();
        geofencePath.forEach((point) => bounds.extend(point));
        const centerCoordinate = bounds.getCenter();

        this.destinationMarkers.push({
          position: {
            lat: centerCoordinate.lat(),
            lng: centerCoordinate.lng(),
          },
          geofence: geofencePath,
        });
      } else if (details['Longtitude'] && details['Latitude']) {
        this.destinationMarkers.push({
          position: {
            lat: parseFloat(details['Latitude']),
            lng: parseFloat(details['Longtitude']),
          },
        });
      }
      //#endregion

      //#region Attachments
      this.attachments = attachments.map((a) => {
        return {
          attachmentaction: '',
          ID: a['ID'],
          FileName: a['File Name'],
          Remarks: a['Remarks'],
          Attachment: a['Attachment'],
        };
      });
      //#endregion
    },
    clearForm: function () {
      this.clearMsgs();
      this.currentTab = 0;
      this.viewMode = false;

      this.destinationCode = '';
      this.destinationCodeError = '';
      this.destinationActive = false;

      this.updatedBy = '';
      this.createdBy = '';

      //#region Destination Details
      this.selectedDestType = null;
      this.destTypeError = '';
      this.selectedCustomerCode = null;
      this.isOwnStagingDest = false;
      this.selectedTariffArea = null;
      this.tariffAreaError = '';
      this.companyName = '';
      this.companyNameError = '';
      this.shortName = '';
      this.shortNameError = '';
      this.address['addressLine1'] = '';
      this.address['addressLine2'] = '';
      this.address['addressLine3'] = '';
      this.address['addressLine4'] = '';
      this.address['postcode'] = '';
      this.address['city'] = '';
      this.address['state'] = '';
      this.address['country'] = '';
      this.addressErrors['addressLine1'] = '';
      this.addressErrors['addressLine2'] = '';
      this.addressErrors['addressLine3'] = '';
      this.addressErrors['addressLine4'] = '';
      this.addressErrors['city'] = '';
      this.isOfficeHrs = false;
      this.requiredTimeDesc = '';
      this.requiredTimeDescError = '';
      this.selectedZone = null;
      this.phone = '';
      this.phoneError = '';
      this.fax = '';
      this.faxError = '';
      this.email = '';
      this.emailError = '';
      this.contact = '';
      this.contactError = '';
      this.hpno = '';
      this.hpnoError = '';
      this.selectedOprTariffArea = null;
      this.selectedPremisesIs = null;
      //#endregion

      //#region Destination Location
      this.remarks = '';
      this.remarksError = '';
      this.avgStuffTime = '';
      this.avgStuffTimeError = '';
      this.avgUnstuffTime = '';
      this.avgUnstuffTimeError = '';
      this.containerCount = '';
      this.containerCountError = '';
      this.destinationMarkers = [];
      this.openMapMenu = false;
      this.confirmAddressPopup = false;
      this.foundAddresses = [];
      this.confirmAddressResolve = null;
      //#endregion

      //#region Attachments
      this.attachments = [];
      this.deletedAttachments = [];
      //#endregion
    },

    attachmentsDeleted: function (deleted) {
      deleted.forEach((d) => {
        if (d['attachmentaction'] != 'N') {
          d['attachmentaction'] = 'D';
          this.deletedAttachments.push(d);
        }
      });
    },

    clearEntryMessages: function () {
      this.requiredMessages = [];
      this.successMessages = [];
      this.entryMessages = [];
      this.Emessages = [];
    },

    entryRequiredClicked: function (item) {
      let errorTabs = this.errorMapping.find((e) => e['key'] == item);

      if (this.currentTab != errorTabs['tab'] && errorTabs['tab'] >= 0) {
        this.currentTab = errorTabs['tab'];
      }

      this.$nextTick(() => {
        switch (errorTabs['key']) {
          case 'addr1':
            this.$refs['addressForm'].setFocus('address1');
            break;

          case 'addr2':
            this.$refs['addressForm'].setFocus('address2');
            break;

          case 'addr3':
            this.$refs['addressForm'].setFocus('address3');
            break;

          case 'addr4':
            this.$refs['addressForm'].setFocus('address4');
            break;

          case 'city':
            this.$refs['addressForm'].setFocus('city');
            break;

          default:
            this.$refs[item].setFocus();
            break;
        }
      });
    },

    //#region Google map function in Destination Location tab
    addressOnMap: async function () {
      let address = `${this.address['addressLine1']} ${this.address['addressLine2']} ${this.address['addressLine3']} ${this.address['addressLine4']} ${this.address['postcode']} ${this.address['city']}, ${this.address['state']} ${this.address['country']}`;
      await this.$refs['customMap'].getMarkerFromAddress(address);
      this.openMapMenu = false;
    },
    addressFromMarker: async function () {
      let addresses = await this.$refs['customMap'].getAddressFromMarker();
      addresses.forEach((a) => (a['checked'] = false));
      this.foundAddresses = addresses;
      this.confirmAddressPopup = true;

      let confirmAddress = await new Promise((r) => (this.confirmAddressResolve = r));
      if (confirmAddress) {
        let number = confirmAddress['address_components'].find((a) => a['types'].includes('street_number'));
        let add1 = confirmAddress['address_components'].find((a) => a['types'].includes('route'));

        let line1 = `${number ? number['long_name'] : ''}, ${add1 ? add1['long_name'] : ''}`;
        let line2 = confirmAddress['address_components'].find((a) => a['types'].includes('sublocality'));
        let postcode = confirmAddress['address_components'].find((a) => a['types'].includes('postal_code'));

        this.address['addressLine1'] = line1;
        this.address['addressLine2'] = line2 ? line2['long_name'] : '';
        this.address['postcode'] = postcode['long_name'];

        this.currentTab = 0;
        this.$nextTick(() => (this.currentTab = 1));
      }
    },
    markLocationByLatLng: function () {
      this.$refs['customMap'].getMarkerByLatLng(this.latLngSearch);
      this.latLngSearch = '';
      this.$nextTick(() => this.addressFromMarker());
    },
    confirmAddressButtonClicked: function (e) {
      if (e == 'Confirm') {
        this.confirmAddressResolve(this.selectedAddress);
      } else {
        this.confirmAddressResolve(null);
      }

      this.confirmAddressPopup = false;
    },
    addressCheckBoxClicked: function (index) {
      let checked = this.foundAddresses.filter((f) => f['checked']);
      if (checked.length > 1) {
        this.$nextTick(() => {
          this.foundAddresses.forEach((f) => (f['checked'] = false));
          this.$nextTick(() => (this.foundAddresses[index]['checked'] = true));
        });
      }
    },
    //#endregion

    //#region Geofence functions

    readFile: function (event) {
      this.geofenceXML = '';
      this.geofenceMatchList = [];

      if (!event[0]) return;
      // console.warn("Event: ", event);
      if (!event[0]['name'].includes('.kml')) {
        this.$showAlert('warning', 'Please upload a kml file');
        return;
      }
      let file = event[0];
      const reader = new FileReader();
      reader.onload = (res) => {
        // console.warn("RESULT");
        // console.log(res.target.result);
        this.geofenceXML = res.target.result;
      };
      reader.onerror = (err) => console.log(err);
      reader.readAsText(file);
    },

    //convert XML to JSON
    parseXml: function (xml, arrayTags) {
      let dom = null;
      if (window.DOMParser) dom = new DOMParser().parseFromString(xml, 'text/xml');
      else if (window.ActiveXObject) {
        dom = new ActiveXObject('Microsoft.XMLDOM');
        dom.async = false;
        if (!dom.loadXML(xml)) throw dom.parseError.reason + ' ' + dom.parseError.srcText;
      } else throw new Error('cannot parse xml string!');

      function parseNode(xmlNode, result) {
        if (xmlNode.nodeName == '#text') {
          let v = xmlNode.nodeValue;
          if (v.trim()) result['#text'] = v.trim();
          return;
        }

        let jsonNode = {},
          existing = result[xmlNode.nodeName];
        if (existing) {
          if (!Array.isArray(existing)) result[xmlNode.nodeName] = [existing, jsonNode];
          else result[xmlNode.nodeName].push(jsonNode);
        } else {
          if (arrayTags && arrayTags.indexOf(xmlNode.nodeName) != -1) result[xmlNode.nodeName] = [jsonNode];
          else result[xmlNode.nodeName] = jsonNode;
        }

        if (xmlNode.attributes)
          for (let attribute of xmlNode.attributes) jsonNode[attribute.nodeName] = attribute.nodeValue;

        for (let node of xmlNode.childNodes) parseNode(node, jsonNode);
      }

      let result = {};
      for (let node of dom.childNodes) parseNode(node, result);

      return result;
    },

    getMatchesFromXml: function (geofenceXML, fullDestList) {
      let geofences = this.parseXml(geofenceXML);
      geofences = geofences['kml']['Document']['Placemark'];
      // let geofences = this.geofences;

      let pointsInGeofences = this.getPointsInGeofences(geofences);
      let matchList = [];

      let geofencesWithPoints = pointsInGeofences.filter((geo) => {
        return geo['Points in geofence'].length > 0;
      });

      // Find the best match for the points in each geofence.
      geofencesWithPoints.forEach((geo) => {
        let kmlName = geo['kml data']['Company'];
        let nameList = geo['Points in geofence'].map((match) => match['Company']);
        let codeList = geo['Points in geofence'].map((match) => match['Destination Code']);
        let minScore = 0;

        let bestMatchIndex = this.findBestMatchIndex(kmlName, nameList, codeList, minScore, minScore);

        if (bestMatchIndex) {
          geo['bestMatch'] = geo['Points in geofence'][bestMatchIndex];
        }
      });

      let geofencesWithBestMatch = pointsInGeofences.filter((point) => {
        return point['bestMatch'];
      });

      // Populate matchList with data from fullDestList
      geofencesWithBestMatch.forEach((geo) => {
        let selected = null;
        selected = fullDestList.find((dest) => {
          return dest['Destination Code'] === geo['bestMatch']['Destination Code'];
        });

        matchList.push({
          Geofence: geo['kml data']['Geofence Coordinates'],
          Name: geo['kml data']['Company'],
          Matched: selected ? true : false,
          'Selected Match': selected,
        });
      });

      let geofencesWithoutPoints = pointsInGeofences.filter((point) => {
        return !point['bestMatch'];
      });

      let destListNames = fullDestList.map((dest) => dest['Company']);
      let destListCodes = fullDestList.map((dest) => dest['Destination Code']);

      // Find matches for geofences without points by string-matching
      geofencesWithoutPoints.forEach((geo) => {
        let kmlName = geo['kml data']['Company'];

        let minNameScore = 17;
        let minCodeScore = 23;
        // Setting the score lower might get less accurate results.

        let bestMatchIndex = this.findBestMatchIndex(kmlName, destListNames, destListCodes, minNameScore, minCodeScore);

        let match = null;
        if (bestMatchIndex) {
          match = fullDestList[bestMatchIndex];
        } else {
          // set match to null
          match = bestMatchIndex;
        }

        matchList.push({
          Geofence: geo['kml data']['Geofence Coordinates'],
          Name: kmlName,
          Matched: match ? true : false,
          'Selected Match': match,
        });
      });
      this.geofenceMatchList = matchList;
    },

    //#region functions from verification component

    findBestMatchIndex: function (kmlName, nameList, codeList, minNameScore, minCodeScore) {
      let bestMatch = null;

      let nameMatches = this.findMatches(kmlName, nameList, minNameScore);
      let codeMatches = this.findMatches(kmlName, codeList, minCodeScore);

      if (nameMatches.length > 0 && codeMatches.length > 0) {
        let nameScore = nameMatches[0]['matchScore'];
        let codeScore = codeMatches[0]['matchScore'];

        bestMatch = nameScore > codeScore ? nameMatches : codeMatches;
      } else if (nameMatches.length > 0) {
        bestMatch = nameMatches;
      } else if (codeMatches.length > 0) {
        bestMatch = codeMatches;
      }

      if (bestMatch) {
        let index = bestMatch[0]['matchIndex'];
        return index;
      } else {
        return null;
      }
    },

    findMatches: function (item, list, MINSCORE) {
      // function from the Verification component.
      // given a string, and a list of strings,
      // return a list of strings that are similar to the given string
      // sorted by highest to lowest score.

      // const MINSCORE = 0;
      let v = { item: item };
      v['soundexEncoding'] = listSoundex(list); // All soundex encoding
      v['metaphoneEncoding'] = listDMetaphone(list); // All double metaphone encoding

      let detectedSoundex = soundex(item); // Detected soundex encoding
      let detectedMetaphone = doubleMetaphone(item); // Detected double metaphone encoding

      // console.log(v);

      let levScore = v['soundexEncoding'].map((se) => levenshtein(detectedSoundex, se)); // Get the levenshtein score
      // console.log('levScore', levScore);

      let zeroDistance = levScore.reduce((a, e, i) => {
        // Get the zero distance from the levenshtein score
        e == 0 ? a.push(i) : null;
        return a;
      }, []);
      // console.log('zeroDistance', zeroDistance);

      let scoreTally = zeroDistance.reduce((a, b) => {
        // Get the score tally from the zero distance
        a[b] = 0;
        return a;
      }, {});
      // console.log('scoreTally', scoreTally);

      let firstScore = zeroDistance.map((zd) => levenshtein(v['metaphoneEncoding'][zd][0], detectedMetaphone[0])); // Get the first score
      // console.log('firstScore', firstScore);
      let firstFinalScore = firstScore.map((n, i) => {
        // Finalize the first score
        let max = Math.max(detectedMetaphone[0].length, v['metaphoneEncoding'][i][0].length);
        let num = max == 0 ? '1' : max;
        let result = (((num - n) / num) * 5).toPrecision(3);
        return result === '5.00' ? '6.00' : result;
      });
      // console.log('firstFinalScore', firstFinalScore);

      let secondScore = zeroDistance.map((zd) => levenshtein(v['metaphoneEncoding'][zd][1], detectedMetaphone[1])); // Get the second score
      // console.log('secondScore', secondScore);
      let secondFinalScore = secondScore.map((n, i) => {
        // Finalize the second score
        let max = Math.max(detectedMetaphone[1].length, v['metaphoneEncoding'][i][1].length);
        let num = max == 0 ? '1' : max;
        let result = (((num - n) / num) * 5).toPrecision(3);
        return result === '5.00' ? '6.00' : result;
      });
      // console.log('secondScore', secondFinalScore);

      let defLevScore = zeroDistance.map((zd) => {
        // Calculate the percentage of score
        let newIndex = recalculateIndex(zd, list.length);
        let data = list[newIndex];
        let score = levenshtein(item, data.toUpperCase());
        let num = Math.max(item.length, data.length);
        let result = (((num - score) / num) * 10).toPrecision(3);
        return result === '10.0' ? '11.0' : result || 0;
      });
      // console.log('defLevScore', defLevScore);

      let allKeys = Object.keys(scoreTally);
      allKeys.forEach((k, ki) => (scoreTally[k] = firstFinalScore[ki])); // Update score from first final score
      allKeys.forEach(
        (k, ki) => (scoreTally[k] = (parseFloat(scoreTally[k]) + parseFloat(secondFinalScore[ki])).toPrecision(3)),
      ); // Update score from second final score
      allKeys.forEach(
        (k, ki) => (scoreTally[k] = (parseFloat(scoreTally[k]) + parseFloat(defLevScore[ki])).toPrecision(3)),
      ); // Update score from the percentage
      // console.log('allKeys', allKeys);

      let scoreTallySorted = Object.entries(scoreTally).sort(([, a], [, b]) => b - a); // Sort the score tally
      if (MINSCORE > 0) scoreTallySorted = scoreTallySorted.filter((st) => parseFloat(st[1]) >= MINSCORE); // Get the score tally after sorted that is more than the set minimum only
      // console.log('scoreTallySorted', scoreTallySorted);

      let matchedData = scoreTallySorted.map((st) => {
        let index = recalculateIndex(st[0], list.length);
        return { item: item, match: list[index], matchScore: parseFloat(st[1]), matchIndex: index };
      }); // Data used in the table box
      // console.log('matchedData', matchedData);

      return matchedData;

      //#region sound encoding

      function listSoundex(list) {
        let soundexEncoding = [];
        for (let i = 0; i < list.length; i++) {
          let name = list[i];
          let code = soundex(name);
          soundexEncoding.push(code);
        }
        return soundexEncoding;
      }
      function soundex(name) {
        let s = [];
        let si = 1;
        let c;
        let mappings = '01230120022455012623010202';
        try {
          s[0] = name[0].toUpperCase();
          for (let j = 0; j < name.length; j++) {
            c = name[j].toUpperCase().charCodeAt(0) - 65;
            if (c >= 0 && c <= 25) {
              if (mappings[c] != '0') {
                if (mappings[c] != s[si - 1]) {
                  s[si] = mappings[c];
                  si++;
                }
                if (si > 3) {
                  break;
                }
              }
            }
          }
          if (si <= 3) {
            while (si <= 3) {
              s[si] = 0;
              si++;
            }
          }
          s = s.join('');
        } catch (err) {
          s = '';
        }
        return s;
      }
      function listDMetaphone(list) {
        let dMetaphoneEncoding = [];
        for (let i = 0; i < list.length; i++) {
          let name = list[i];
          let code = doubleMetaphone(name);
          dMetaphoneEncoding.push(code);
        }
        return dMetaphoneEncoding;
      }
      function levenshtein(s, t) {
        if (s === t) {
          return 0;
        }
        var n = s.length,
          m = t.length;
        if (n === 0 || m === 0) {
          return n + m;
        }
        var x = 0,
          y,
          a,
          b,
          c,
          d,
          g,
          h,
          k;
        var p = new Array(n);
        for (y = 0; y < n; ) {
          p[y] = ++y;
        }

        for (; x + 3 < m; x += 4) {
          var e1 = t.charCodeAt(x);
          var e2 = t.charCodeAt(x + 1);
          var e3 = t.charCodeAt(x + 2);
          var e4 = t.charCodeAt(x + 3);
          c = x;
          b = x + 1;
          d = x + 2;
          g = x + 3;
          h = x + 4;
          for (y = 0; y < n; y++) {
            k = s.charCodeAt(y);
            a = p[y];
            if (a < c || b < c) {
              c = a > b ? b + 1 : a + 1;
            } else {
              if (e1 !== k) {
                c++;
              }
            }

            if (c < b || d < b) {
              b = c > d ? d + 1 : c + 1;
            } else {
              if (e2 !== k) {
                b++;
              }
            }

            if (b < d || g < d) {
              d = b > g ? g + 1 : b + 1;
            } else {
              if (e3 !== k) {
                d++;
              }
            }

            if (d < g || h < g) {
              g = d > h ? h + 1 : d + 1;
            } else {
              if (e4 !== k) {
                g++;
              }
            }
            p[y] = h = g;
            g = d;
            d = b;
            b = c;
            c = a;
          }
        }

        for (; x < m; ) {
          var e = t.charCodeAt(x);
          c = x;
          d = ++x;
          for (y = 0; y < n; y++) {
            a = p[y];
            if (a < c || d < c) {
              d = a > d ? d + 1 : a + 1;
            } else {
              if (e !== s.charCodeAt(y)) {
                d = c + 1;
              } else {
                d = c;
              }
            }
            p[y] = d;
            c = a;
          }
          h = d;
        }

        return h;
      }

      //#endregion

      function recalculateIndex(ind, length) {
        let newIndex = 0;
        if (ind >= length) {
          newIndex = ind - length;
          while (newIndex >= length) {
            newIndex -= length;
          }
        } else {
          newIndex = ind;
        }

        return newIndex;
      }

      //#endregion
    },

    closeUploadPopup: async function (showConfirm = false) {
      if (showConfirm && this.geofenceXML !== '') {
        let close = await this.$showAlert('info', 'Close Import Geofence?', 'Changes will not be saved', [
          { text: 'Close', color: '#ff7676' },
          { text: 'Cancel' },
        ]);
        if (close === 'Cancel') {
          return;
        }
      }
      this.showImportGeofencePopup = false;
      this.geofenceMatchList = [];
      this.geofenceXML = '';
    },

    submitGeofenceFile: async function () {
      let submit = await this.$showAlert('info', 'Submit Geofences?', ' ', [
        { text: 'Confirm', color: '#5de986' },
        { text: 'Cancel' },
      ]);
      if (submit === 'Cancel') {
        return;
      }

      // console.log("matchlist to post: ", this.matchListToPost);
      let dataArrayToPost = getDataArrayToPost(this.matchListToPost);
      // console.log("data array to post: ", dataArrayToPost);

      this.$fullscreenLoading('Saving geofences');
      let allResults = await this.updateGeofence(dataArrayToPost);
      this.$fullscreenLoading();
      let errorMessage = await this.getErrorMessages(allResults);

      let failedToSave = [];

      if (errorMessage['noOfErrors'] === 0) {
        this.getAllDestination();
        this.viewMode = true;
        this.$showAlert('success', 'Successfully saved all Geofences!');
      } else {
        this.getAllDestination();
        this.viewMode = true;
        await this.$showAlert(
          'success',
          `Successfully saved ${errorMessage['noOfSuccesses']} out of ${errorMessage['total']} Geofences!`,
          errorMessage['errorMessage'],
        );
      }

      this.closeUploadPopup();
      this.geofenceMatchList = [];
      this.geofenceXML = '';

      function getDataArrayToPost(matchList) {
        let dataToPost = [];
        matchList = matchList.filter((match) => {
          return typeof match['Selected Match'] === 'object';
        });
        matchList.forEach((match) => {
          if (!match['Selected Match'] || match['Selected Match'] === '') return;
          dataToPost.push(match);
        });

        return dataToPost;
      }
    },

    updateGeofence: async function (dataArrayToPost) {
      let results = [];
      for (let i = 0; i < dataArrayToPost.length; i++) {
        let data = dataArrayToPost[i];
        this.selectedDest = [data['Selected Match']];

        let APIResult = await this.$apiCallV2(
          `/DestinationList/GetDetailsMaster?recordID=${this.selectedDest[0]['Destination Code']}`,
        );
        if (APIResult) {
          APIResult = APIResult['Destination'];
        } else {
          continue;
        }
        let zone = this.zoneList.find((z) => z['Zone Type'] == APIResult['ZoneType']);
        let area = this.tariffAreaList.find((t) => t['Area Code'] == APIResult['CHAMAreaCode']);
        let cu = this.customerCodeList.find((c) => c['Customer Code'] == APIResult['Cu_number']);
        // let details = this.$jsonNullToStringV2(this.$deepTrimJsonV3((await )));
        let dataToPost = {
          action: 'E',
          Destination_code: APIResult['Destination_code'],
          Cu_Number: cu ? cu['Customer Code'] : '',
          Company: APIResult['Company'],
          Addr1: APIResult['Addr1'],
          ZoneType: zone ? zone['Zone Type'] : '',
          CHAMAreaCode: area ? area['Area Code'] : '',
          Geofence: data['Geofence'],
        };
        results.push(this.$apiCallV2('/DestinationList/SaveDestination', dataToPost));
      }

      return results;
    },

    submitGeofenceButtonClicked: function (e) {
      if (e == 'Confirm') {
        this.submitGeofenceFile();
      }
      this.showSubmitGeofencePopup = false;
    },

    getErrorMessages: async function (allResults) {
      // console.log("Get error messages ");
      let errors = [];
      let img =
        '<img src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Warning.svg/1200px-Warning.svg.png" style="height: 2em"/>';

      let errorMessage = '\n' + img + ' <b>Failed to save geofences for these locations: </b>\n\n';
      for (let i = 0; i < allResults.length; i++) {
        let res = await allResults[i];
        if (res && res[0]['Results'] >= 1) {
          // console.log("More than 1");
          errors.push(res[0]);
        }
      }

      // console.log("Errors: ", errors);
      if (errors.length == 0) return '';

      for (let i = 0; i < errors.length; i++) {
        // console.log("Printing errors");
        // console.log("Finding destination code: ", errors[i]['Destination_Code']);
        let destination = this.fullDestList.find((dest) => dest['Destination Code'] === errors[i]['Destination_Code']);
        errors[i]['Company'] = destination ? destination['Company'] : '';
        // console.log("Destination: ", errors[i]['Company']);
        errorMessage +=
          errors[i]['Destination_Code'] + ' ' + errors[i]['Company'] + '\nError: ' + errors[i]['ErrMsg'] + '\n\n';
      }
      return {
        total: allResults.length,
        noOfSuccesses: allResults.length - errors.length,
        noOfErrors: errors.length,
        errorMessage: errorMessage,
      };
    },

    getPointsInGeofences: function (geofences) {
      let destWithCoordinates = this.getdestWithCoordinates();
      let allGeofences = this.getAllGeofences(geofences);
      // console.log("destWithCoordinates:", destWithCoordinates);
      // console.log("allGeofences: ", allGeofences);

      let pointsInPoly = [];
      // console.log("Finding matches");
      allGeofences.forEach((geofence) => {
        let pointsInGeofence = [];
        for (let i = 0; i < destWithCoordinates.length; i++) {
          let dest = destWithCoordinates[i];

          if (pointInPoly(geofence, dest)) {
            pointsInGeofence.push(dest);
            // break;
          }
        }
        // if(pointsInGeofence.length === 0){
        // 	return;
        // }
        pointsInPoly.push({
          'kml data': geofence,
          'Points in geofence': pointsInGeofence,
        });
      });
      return pointsInPoly;

      function pointInPoly(geofence, dest) {
        let geofenceCoordinates = [];
        geofence['Geofence Coordinates'].forEach((coord) => {
          geofenceCoordinates.push({
            lat: parseFloat(coord['gfLat']),
            lng: parseFloat(coord['gfLon']),
          });
        });

        let destCoordinates = {
          lat: dest['Coordinates']['lat'],
          lng: dest['Coordinates']['lng'],
        };

        const polygon = new google.maps.Polygon({
          paths: geofenceCoordinates,
        });

        return google.maps.geometry.poly.containsLocation(destCoordinates, polygon);
      }
    },

    getdestWithCoordinates: function () {
      let destListWithCoordinates = this.fullDestList.filter((dest) => {
        let lat = parseFloat(dest['Latitude']);
        let lon = parseFloat(dest['Longitude']);
        return !isNaN(lat) && !isNaN(lon) && lat !== 0 && lon !== 0;
      });

      let destinations = [];
      destListWithCoordinates.forEach((dest) => {
        destinations.push({
          Company: dest['Company'],
          'Destination Code': dest['Destination Code'],
          Coordinates: {
            lat: parseFloat(dest['Latitude']),
            lng: parseFloat(dest['Longitude']),
          },
        });
      });

      return destinations;
    },

    getAllGeofences: function (geofences) {
      let allGeofences = [];
      geofences.forEach((geo) => {
        let geofence = getGeofenceCoordinates(geo);
        if (geofence) {
          allGeofences.push({
            Company: geo['name']['#text'],
            'Geofence Coordinates': geofence,
          });
        }
      });
      return allGeofences;

      function getGeofenceCoordinates(geo) {
        if (!geo['Polygon']) {
          return false;
        }
        let arr = geo['Polygon']['outerBoundaryIs']['LinearRing']['coordinates']['#text'].slice(0, -2).split(',0 ');
        for (let i = 0; i < arr.length; i++) {
          arr[i] = arr[i].split(',');
        }
        let geofence = [];
        arr.forEach((coords, i) => {
          geofence.push({
            VertexID: (i + 1).toString(),
            gfLat: coords[1].toString(),
            gfLon: coords[0].toString(),
          });
        });
        return geofence;
      }
    },

    //#endregion

    //#region Activate for Clock In/Out
    destSelected: function(row, selected) {
      if (selected) {
        this.isDeactivate = row['Clock In/Out'] != 'Deactivated';
      } else {
        this.isDeactivate = false;
      }
      this.menu.getSelected('MnuActivateClockInOut', 'key')['title'] = this.activateClockInOutMenuTitle;
    },
    loadActivateClockInOutPopup: async function () {
      this.$fullscreenLoading('Getting Details');
      const data = this.$jsonNullToStringV2((
          await this.$apiCallV2(`/DestinationList/GetDetailsMaster?recordID=${this.selectedDest[0]['Destination Code']}`)
        )['Destination'],
      );
      this.$fullscreenLoading();

      if (!data['Geofence']) {
        this.$showAlert('error', 'Geofence Not Set', 'Please set a geofence for this destination to activate for clock in/out.');
        return;
      }

      this.clockInOutGeofence = data['Geofence'];

      // Fill in map details
      if (data['Longtitude'] && data['Latitude']) {
        const geofencePath = this.clockInOutGeofence.map((g) => ({
          lat: parseFloat(g['gfLat']),
          lng: parseFloat(g['gfLon']),
        }));
        this.clockInOutMarkers.push({
          position: {
            lat: parseFloat(data['Latitude']),
            lng: parseFloat(data['Longtitude']),
          },
          geofence: geofencePath,
        });
      } else {
        this.$showAlert('error', 'Longitude and Latitude Required', 'Unable to activate this destination without the required fields.')
        return;
      }

      // Fill in address details
      this.companyName = data['Company'];
      this.shortName = data['Destination'];
      this.address['addressLine1'] = data['Addr1'] ?? '';
      this.address['addressLine2'] = data['Addr2'] ?? '';
      this.address['addressLine3'] = data['Addr3'] ?? '';
      this.address['addressLine4'] = data['Addr4'] ?? '';
      this.address['postcode'] = data['PostCode'] ?? '';
      this.address['city'] = data['City'] ?? '';
      this.address['state'] = data['State'] ?? '';
      this.address['country'] = data['Country'] ?? '';
      
      this.showActivateClockInOutPopup = true;
    },
    activateClockInOutButtonClicked: async function (e) {
      if (e == 'Confirm') {
        this.$fullscreenLoading('Saving');
        await this.setClockInOutGeofence();
        this.$fullscreenLoading();
      }

      this.showActivateClockInOutPopup = false;
      this.isDeactivate = false;
      this.clockInOutMarkers = [];
      this.companyName = '';
      this.shortName = '';
      this.address = {
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        postcode: '',
        city: '',
        state: '',
        country: '',
      };
    },
    setClockInOutGeofence: async function () {
      const dataToPost = {
        action: !this.isDeactivate ? 'N' : 'D',
        poicode: this.selectedDest[0]['Destination Code'],
        name: this.selectedDest[0]['Company'],
        addr1: this.address['addressLine1'],
        addr2: this.address['addressLine2'],
        addr3: this.address['addressLine3'],
        addr4: this.address['addressLine4'],
        city: this.address['city'],
        state: this.address['state'],
        postcode: this.address['postcode'],
        country: this.address['country'],
        attn: this.selectedDest[0]['Contact'],
        phone: this.selectedDest[0]['Tel No'],
        phone2: this.selectedDest[0]['Tel No 2'],
        zonetype: this.selectedDest[0]['ZoneType'],
        latitude: Math.round(this.selectedDest[0]['Latitude'] * 10000000000) / 10000000000,
        longitude: Math.round(this.selectedDest[0]['Longitude'] * 10000000000) / 10000000000,
        geofence: this.clockInOutGeofence,
      };
      
      const postUpdate = await this.$apiCallV2('/DestinationList/SaveClockInOutGeofence', dataToPost);
      if (postUpdate[0].Results >= 1) {
        if (!this.isDeactivate)
          this.$showAlert('error', 'Activation Failed', 'Failed to enable destination for clock in/out.');
        else
          this.$showAlert('error', 'Deactivation Failed', 'Failed to disable destination for clock in/out.');
      } else {
        this.getAllDestination();
        this.viewMode = true;
        if (!this.isDeactivate)
          this.$showAlert('success', 'Successfully Activated', 'Destination is enabled for clock in/out!');
        else
          this.$showAlert('success', 'Successfully Deactivated', 'Destination is disabled for clock in/out!');
      }
    },
    //#endregion
  },
  mounted: async function () {
    await this.sasControlFunction();

    const mountedPromises = [];
    let promisesFulfilled = 0;

    // #region All dropdown items
    mountedPromises.push(
      this.getAllDestination().then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'area' }).then((result) => {
        const areas = this.$deepTrimJsonV3(result);
        const areasList = areas.map((item) => {
          return {
            ...item,
            'Area Code - Description': `${item['Area Code']} - ${item['Description']}`,
          };
        });
        this.tariffAreaList = areasList;
        this.oprTariffAreaList = areasList;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'zone' }).then((result) => {
        const zones = this.$deepTrimJsonV3(result);
        this.zoneList = zones.map((item) => {
          return {
            ...item,
            'Zone Type - Description': `${item['Zone Type']} - ${item['Description']}`,
          };
        });
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'customer' }).then((result) => {
        this.customerCodeList = this.$deepTrimJsonV3(result);
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
        this.customerCodeList = this.customerCodeList.map((item) => {
          return {
            ...item,
            'Customer Code - Description': `${item['Customer Code']} - ${item['Customer Name']}`,
          };
        });
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'postcode' }).then((result) => {
        this.postcodeList = this.$deepTrimJsonV3(result);
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'state' }).then((result) => {
        this.stateList = this.$deepTrimJsonV3(result);
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'country' }).then((result) => {
        this.countryList = this.$deepTrimJsonV3(result);
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    //#endregion

    await Promise.allSettled(mountedPromises).then((_promiseOutcomes) => {
      this.menu = this.menu.map((menu) => ({
        ...menu,
        enabled: true,
      }));
    });

    if (this.$route.query['new']) {
      this.companyName = this.$route.query['companyname'] ?? '';
      this.address = {
        addressLine1: this.$route.query['addr1'] ?? '',
        addressLine2: this.$route.query['addr2'] ?? '',
        addressLine3: this.$route.query['addr3'] ?? '',
        addressLine4: this.$route.query['addr4'] ?? '',
        postcode: this.$route.query['postcode'] ?? '',
        city: this.$route.query['city'] ?? '',
        state: this.$route.query['state'] ?? '',
        country: this.$route.query['country'] ?? '',
      };
      this.phone = this.$route.query['phoneno'] ?? '';
      this.fax = this.$route.query['faxno'] ?? '';

      this.menuClicked({ title: 'New Destination' });
    }
  },
  watch: {
    showPopup: async function (val) {
      if (!val && this.$route.query['new'] && !this.viewMode) {
        // When the cancel is click but is not saved (for query new=1)
        let closeWindow = await this.$showAlert(
          'warning',
          'Cancelling Destination Creation',
          `You have not created an Destination profile.\nAre you sure you want to cancel?\n\nIf you cancel, this page will close.`,
          [{ text: 'Continue Creating' }, { text: 'Cancel Creating', color: 'red', textColor: 'white' }],
        );

        if (closeWindow == 'Cancel Creating') {
          // If user choose to cancel the creating process, it will close the tab
          window.close();
        } else {
          this.showPopup = true;
        }
      } else if (!val && this.$route.query['new'] && this.viewMode) {
        window.close();
      }

      if (!val) {
        this.clearForm();
      }
    },
    selectedDest: function (val) {
      if (val.length > 0) {
        let lat = val[0]['Latitude'];
        let lng = val[0]['Longitude'];
        if (lat && lng) {
          this.$refs['mainMap'].placeMarker([
            {
              position: { lat: parseFloat(lat), lng: parseFloat(lng) },
              geofence: null,
            },
          ]);
        } else {
          this.$refs['mainMap'].placeMarker([]);
        }
      } else {
        this.$refs['mainMap'].placeMarker([]);
      }
    },
    geofenceXML: function () {
      if (this.geofenceXML === '') {
        return;
      }
      this.$fullscreenLoading('Finding matches');
      this.getMatchesFromXml(this.geofenceXML, this.fullDestListForGeofence);
      this.$fullscreenLoading();
    },
  },
};
</script>

<style lang="scss" scoped>
.main-dest {
  width: 100%;
  height: 100%;
  padding: 10px 45px;
  overflow: hidden;
  display: flex;
  font-size: 12px;
}

.main-dest2 {
  display: flex;
  flex-direction: column;
  // width: auto;
  // height: auto;
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin-left: 5px;

  > .map-container,
  > .table-container {
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    height: 100%;
    width: 100%;
    margin-top: 5px;
    transition: 0.3s;
  }

  > .map-container {
    margin-top: unset;
  }

  > #upload-popup {
    position: absolute;
    height: 85vh;
    width: 85vw;
    background-color: white;
    z-index: 100;
    top: 45vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    padding: 20px;
    border: 3px solid grey;

    > .close-button {
      position: absolute;
      right: 30px;
    }

    > .submit-button {
      position: absolute;
      right: 30px;
      bottom: 20px;
    }

    > .legend-container {
      position: absolute;
      bottom: 20px;
      border: 1px solid grey;
      border-radius: 5px;
      padding: 10px;
    }

    > .match-container {
      display: flex;

      > .no-matches-found,
      .match-found {
        width: 100%;

        > .title {
          font-size: 1.25em;
          font-weight: bold;
          text-align: center;
        }

        > .title-container {
          display: flex;
          border-bottom: 1px solid grey;

          > &:first-child {
            margin-right: 10px;
          }

          > .title {
            font-weight: bold;
            width: 100%;
            text-align: center;
          }
        }

        > .list-container {
          height: 55vh;
          overflow: auto;

          // background-color: green;
          > .list-item {
            display: flex;
            min-height: 4em;
            align-items: center;
            padding: 20px;

            &:nth-child(even) {
              background-color: rgb(244, 244, 244);
            }

            > div {
              width: 100%;
            }

            > .name {
              // text-align: right;
              margin-right: 10px;
            }

            > .match {
              display: flex;
            }
          }
        }
      }

      > .no-matches-found {
        border-right: 1px solid grey;
      }
    }
  }
}

.tabBox {
  width: 100%;
  height: 100%;
  position: relative;
}

.tabtab {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0px;
  bottom: 38px;
}

#destMap {
  width: 100%;
  flex: 1;
}

.destTable {
  padding-bottom: 2.5%;
}

#destTabulator {
  padding: 0;
  width: 100%;
  font-size: 12px;
}

.destination-code {
  display: flex;
  align-items: center;
}

.address_details {
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 5px;

  &:not(:first-child) {
    margin-top: 5px;
  }
}

.flex-row {
  display: flex;
  align-items: center;

  > * {
    width: 100%;
  }

  > :not(:first-child) {
    margin-left: 5px;
  }
}
</style>
